import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
export default {
  DoGetBannerItems() {
    return API.peakAPI.get("/api/Banner/GetBannerThumbnail", userInfo.SetHeaderService()).then((res) => {
      return res.data;
    });
  },
  DoGetBannerDetail(code) {
    return API.peakAPI.get(`/api/Banner/GetBannerDetail?code=${code}`, userInfo.SetHeaderService()).then((res) => {
      return res.data;
    });
  },
};
